import { useSelector } from 'react-redux';

const useRole = () => {
  const role = useSelector((state) => state.authUser.role);
  return role;
};

export default useRole;
